import { EmailAPI } from 'api'

export const fetchSendingDomains = () =>
  EmailAPI.get('/sending_domains').then((res) => res.data)

export const verifySendingDomain = (id) =>
  EmailAPI.get(`/sending_domains/${id}/verify`).then((res) => res.data)

export const deleteSendingDomain = (id) =>
  EmailAPI.delete(`/sending_domains/${id}`)

export const createSendingDomain = (domain, keyLength) =>
  EmailAPI.post('/sending_domains/', { domain, keyLength }).then(
    (res) => res.data
  )
